import { Box } from '@chakra-ui/react'
import UserTable from './componenets/UserTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <UserTable />
    </Box>
  )
}
